export default __webpack_public_path__ + "static/media/case-li2.81c9f1fc.png";